import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ApiService } from './service/api.service';
import {AppClipsModule} from './app-clips/app-clips.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NewAppClipsComponent } from './new-app-clips/new-app-clips.component';
import {NgxQRCodeModule} from '@techiediaries/ngx-qrcode';
import {ClipboardModule} from 'ngx-clipboard';
import { NotifierModule } from 'angular-notifier';
import {NgxMaskModule} from "ngx-mask";

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    NewAppClipsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AppClipsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxQRCodeModule,
    ClipboardModule,
    NotifierModule,
    NgxMaskModule.forRoot()
  ],
  providers: [
    AsyncPipe,
    ApiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
